import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Accordion, Text, Link} from 'components/UIKit';
import styles from '../../frequently-asked-questions.scss';
import * as locales from './locales';

interface BuyerFAQProps {}

export function BuyerFAQComponent({i18n}: WithI18nProps & BuyerFAQProps) {
  return (
    <Accordion title={i18n.translate('buyers')}>
      <Accordion.Item title={i18n.translate('whatIsExchange')}>
        <Text component="p">{i18n.translate('exchangeIs')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('onExchange')}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('isExchangeSafe')}>
        <Text component="p">{i18n.translate('exchangeIsSafe')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('protectBuyers', {
            url1: generateLink(i18n.translate('exchangeIsSafeUrl'), i18n.translate('learnMore')),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('ifSellerNotResponding')}>
        <Text component="p">{i18n.translate('sellerNotResponding')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('weRecommend')}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('noStoreIlike')}>
        <Text component="p" resetMargin>
          {i18n.translate('makeYourOwn', {
            url1: generateLink(
              i18n.translate('shopifySignupUrl'),
              i18n.translate('startYourOwnBusiness'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howToBuyStore')}>
        <Text component="p">
          {i18n.translate('toBuyerStore', {
            url1: generateLink(
              i18n.translate('whyOnlyUseEscrowUrl'),
              i18n.translate('escrowDotCom'),
            ),
          })}
        </Text>
        <Text component="p" resetMargin>
          {i18n.translate('makeMostOfIt', {
            url1: generateLink(
              i18n.translate('buyerProtectionUrl'),
              i18n.translate('buyerProtection'),
            ),
            url2: generateLink(
              i18n.translate('whyOnlyUseEscrowUrl'),
              i18n.translate('escrowCreateBySeller'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('isThereBuyerFee')}>
        <Text component="p" resetMargin>
          {i18n.translate('noBuyerFee')}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('whatQuestionsToAskSeller')}>
        <Text component="p">{i18n.translate('questionsToAskSeller')}</Text>
        <ul className={styles.list}>
          <Text component="li">{i18n.translate('howDoPeople')}</Text>
          <Text component="li">{i18n.translate('whatAreTheProfitMargins')}</Text>
          <Text component="li">{i18n.translate('storeSuppliers')}</Text>
        </ul>
        <Text component="p" resetMargin>
          {i18n.translate('moreIdeas', {
            url1: generateLink(
              i18n.translate('whatToAskSellerUrl'),
              i18n.translate('whatToAskSeller'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('whereFromRevenueAndTraffic')}>
        <Text component="p">{i18n.translate('useOfficialExchangeApp')}</Text>
        <Text component="p">{i18n.translate('thisAllowsExhcange')}</Text>
        <Text component="p" resetMargin>
          {i18n.translate('howSalesVerified', {
            url1: generateLink(
              i18n.translate('howDataVerifiedByExchangeUrl'),
              i18n.translate('learnMore'),
            ),
          })}
        </Text>
      </Accordion.Item>
      <Accordion.Item title={i18n.translate('howToReportSeller')}>
        <Text component="p" resetMargin>
          {i18n.translate('reportSerllerBy', {
            url1: generateLink(i18n.translate('exchangeEmailUrl'), i18n.translate('exchangeEmail')),
          })}
        </Text>
      </Accordion.Item>
    </Accordion>
  );
}

const generateLink = (url, text) => {
  return <Link rel="noopener noreferrer" type="regular" forcePink url={url} text={text} newTab />;
};

export const BuyerFAQ = withI18n({
  id: 'BuyerFAQ',
  fallback: locales.en,
})(BuyerFAQComponent);
